import React from 'react';
import { Box, Pagination } from '@mui/material';

const CustomPagination = ({ count, page, onChange, }) => {
    return (
        <Box sx={{ display: 'flex', justifyContent: 'right', mt: 2 }}>
            <Pagination
                count={count}
                page={page}
                onChange={onChange}
                sx={{color:'rgba(29, 57, 105, 1) !important'}}
                size="small"

            />
        </Box>
    );
};

export default CustomPagination;
